module.exports = __webpack_public_path__ + "static/img/214_phase_function_Paper_PointsHejduk_Prediction.7474d84.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/214_phase_function_Paper_PointsHejduk_Prediction.png
// module id = JgZP
// module chunks = 0